import styles from './styles/PlanTable.css'
import PlanData from '../../../config/static/pricing-plans'
import Button from '../forms/Button'
import { toggleModal } from '../../store/ui/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import CircleSpinner from '../misc/CircleSpinner'
import * as analytics from 'lib/analytics'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import Card from '../layout/Card'
import { getLocalCurrencyAmount, getLocalCurrency } from '../../lib/get-local-price'
import { setMode } from '../../store/login-modal/actions'
import InfoBanner from 'components/forms/InfoBanner'
import Link from 'components/misc/Link'
import { getUserCountry } from 'lib/util'

const getPriceID = (annual) => {
  return annual ? CONFIG.stripe.premiumPlanAnnuallyPriceID : CONFIG.stripe.premiumPlanMonthlyPriceID
}

const parseFloatFromCurrencyString = (localedPrice) => {
  const parsed = localedPrice.match(/[0-9.]+/)
  if (!parsed) {
    return null
  }
  return Number.parseFloat(parsed[0]) || null
}

const ShareASalePixel = ({ orderID }) => {
  const location = useLocation()
  const query = qs.parse(location.search)
  if (query.session_id && query.amount && CONFIG.sciteFrontendURL === 'https://scite.ai') {
    return (
      <img src={`https://www.shareasale.com/sale.cfm?tracking=${orderID}&amount=${query.amount}&merchantID=113325&transtype=sale`} width='1' height='1' />
    )
  }
  return null
}

const PlanTable = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const user = useSelector(({ ui }) => ui.user)
  const [loading, setLoading] = useState(false)
  const [success, setSucess] = useState(false)
  const [currency, setCurrency] = useState()
  const [annualPrice, setAnnualPrice] = useState()
  const [annualPriceMonthly, setAnnualPriceMonthly] = useState()
  const [monthlyPrice, setMonthlyPrice] = useState()
  const [annualDiscountPct, setAnnualDiscountPct] = useState('')

  useEffect(() => {
    setMonthlyPrice(getLocalCurrencyAmount('monthly'))
    setAnnualPriceMonthly(getLocalCurrencyAmount('annual', true))
    setAnnualPrice(getLocalCurrencyAmount('annual'))
    setCurrency(getLocalCurrency())
  }, [])

  useEffect(() => {
    if (!monthlyPrice || !annualPriceMonthly) {
      return
    }
    const monthlyPriceNumeric = parseFloatFromCurrencyString(monthlyPrice)
    const annualMonthlyPriceNumeric = parseFloatFromCurrencyString(annualPriceMonthly)
    if (!monthlyPriceNumeric || !annualMonthlyPriceNumeric) {
      return
    }

    const pctDiscount = `${(((monthlyPriceNumeric - annualMonthlyPriceNumeric) / (monthlyPriceNumeric)) * 100).toFixed(0)}%!`
    setAnnualDiscountPct(pctDiscount)
  }, [monthlyPrice, annualPriceMonthly])

  useEffect(() => {
    const query = qs.parse(location.search)
    if (query.session_id && query.plan) {
      setSucess(true)
      analytics.rawGtag('event', 'purchase', {
        currency: 'USD',
        transaction_id: Date.now(),
        value: query.amount,
        items: [{
          name: (query.plan || '') + ` ${query.annual ? 'annual' : 'monthly'}`,
          price: query.amount,
          quantity: 1,
          currency: 'USD'
        }]
      })
      analytics.event({
        category: 'User',
        action: 'Purchased Plan',
        label: query.plan
      })
    }
  }, [location])

  const handleClick = (plan, annual) => (e) => {
    if (!user) {
      e.preventDefault()
      dispatch(setMode('register'))
      dispatch(toggleModal('login'))
      return
    }
    setLoading(true)

    // Since users will be pressing the back button
    // and that won't trigger normal mounting/unmounting behaviour
    // we need to clear this on timeout...
    setTimeout(() => {
      setLoading(false)
    }, 5000)

    analytics.event({
      category: 'User',
      action: 'View Checkout',
      label: plan
    })

    const planInfo = PlanData[plan]

    analytics.rawGtag('event', 'view_item', {
      currency: 'USD',
      value: parseFloat(annual ? planInfo.annualPrice : planInfo.monthlyPrice) || 0,
      items: [{
        name: plan + ` ${annual ? 'annual' : 'monthly'}`,
        price: parseFloat(annual ? planInfo.annualPrice : planInfo.monthlyPrice) || 0,
        quantity: 1,
        currency: 'USD'
      }]
    })
  }

  let checkoutMethod = 'POST'
  let checkoutURL = CONFIG.stripe.checkoutSessionURL
  let cta = 'Upgrade now'
  if (user?.subscription?.customerID && (user?.subscription?.status === 'active' || user?.subscription?.status === 'trialing')) {
    checkoutURL = '/users/me/subscription'
    cta = 'Manage plan'
    checkoutMethod = 'GET'
  } else if (!user || (user?.subscription?.plan === 'free' && !user?.activatedTrial)) {
    checkoutURL = CONFIG.stripe.trialCreationURL
    cta = 'Start your free trial'
  }
  const showCharlesworthBanner = getUserCountry() === 'China'

  let rewardfulID = ''
  // check if window.Rewardful.referral is on window
  if (typeof window !== 'undefined' && window?.Rewardful?.referral) {
    rewardfulID = window.Rewardful.referral
  }
  return (
    <div className={styles.planTableContainer}>
      {success && user?.subscription?.subID && (
        <ShareASalePixel
          orderID={user?.subscription?.subID}
        />
      )}

      <div className={styles.plansContainer}>
        <Card level={3} className={styles.planContainer}>
          <div className={styles.iconContainer}><img alt='plan-illustration' className={styles.icon} src={`${CONFIG.assetsBaseURL}/images/pricing/microscope.svg`} /></div>
          <div className={styles.header}>Monthly Plan</div>
          {(!user || (user?.subscription?.plan === 'free' && !user?.activatedTrial)) && (
            <div className={styles.sevenDaysFree}>
              {CONFIG.trialLength} days free, then
            </div>
          )}
          <div className={styles.pricing}>
            <span className={styles.price}>{monthlyPrice}</span>
          </div>

          <div className={styles.subheading}>
            per month
          </div>
          <div className={styles.cancelAnyTimeText}>
            cancel anytime
          </div>

          <form action={checkoutURL} method={checkoutMethod}>
            <input type='hidden' name='priceId' value={getPriceID(false)} />
            <input type='hidden' name='plan' value='premium' />
            <input type='hidden' name='annual' value='false' />
            <input type='hidden' name='currency' value={currency} />
            <input type='hidden' name='rewardfulID' value={rewardfulID} />
            <Button
              className={styles.cta}
              color='blue'
              onClick={handleClick('premium', false)}
              bold
            >
              {loading
                ? <CircleSpinner size={10} color='white' />
                : cta}
            </Button>
          </form>
        </Card>

        <Card level={3} className={styles.planContainer}>{(annualDiscountPct) && (<span className={styles.pctOff}>Save {annualDiscountPct}</span>)}
          <div className={styles.iconContainer}><img alt='plan-illustration' className={styles.icon} src={`${CONFIG.assetsBaseURL}/images/pricing/bill.svg`} /></div>
          <div className={styles.header}>Yearly Plan</div>
          {(!user || (user?.subscription?.plan === 'free' && !user?.activatedTrial)) && (
            <div className={styles.sevenDaysFree}>
              {CONFIG.trialLength} days free, then
            </div>
          )}
          <div className={styles.pricing}>
            <span className={styles.price}>{annualPriceMonthly}</span>
          </div>

          <div className={styles.subheading}>
            {annualPriceMonthly} per month, paid annually ({annualPrice})
          </div>
          <div className={styles.cancelAnyTimeText}>
            cancel anytime
          </div>

          <form action={checkoutURL} method={checkoutMethod}>
            <input type='hidden' name='priceId' value={getPriceID(true)} />
            <input type='hidden' name='plan' value='premium' />
            <input type='hidden' name='annual' value='true' />
            <input type='hidden' name='currency' value={currency} />
            <Button
              className={styles.cta}
              color='blue'
              onClick={handleClick('premium', true)}
              bold
            >
              {loading
                ? <CircleSpinner size={10} color='white' />
                : cta}
            </Button>
          </form>
        </Card>
      </div>

      {showCharlesworthBanner && (
        <InfoBanner state='info' className={styles.charlesworthBanner}>
          <span>
            It looks like you're based in China; to make it easier, you can also purchase an annual scite subscription <Link href='https://www.cwauthors.com.cn/Scite_' underline blue>from our distribution partner, The Charlesworth Group</Link>.
          </span>
        </InfoBanner>
      )}
    </div>
  )
}

export default PlanTable
